import 'rxjs/add/operator/combineLatest';
import fuse from '../../../_libs/redux-fusion';
import {TaskType} from '../../enums/TaskType';
import {projectTasksCtrlConfig} from '../../router-project-tasks';
import {TaskViewActivityContainer} from './TaskViewActivityContainer';
import {TaskViewActivityView} from './TaskViewActivityView';


const StreamedComponent = TaskViewActivityContainer({
  taskType: TaskType.PROJECT,
  taskListState: projectTasksCtrlConfig.taskListState,
});

export const ProjectTaskViewActivityContainer = fuse(StreamedComponent)(TaskViewActivityView);



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskViewActivity/ProjectTaskViewActivityContainer.js